'use client'

import { useClientMounted } from '@/hooks/use-client-mounted'
import { LOCALE_INIT_SCRIPT } from '@/lib/i18n/client-locale'

export function LocaleInitScript() {
  const isClientMounted = useClientMounted()

  return (
    <script type={isClientMounted ? 'application/json' : undefined}>{LOCALE_INIT_SCRIPT}</script>
  )
}
